// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"eb58b591","431":"aad31fa1","453":"1ca2f8d4"}[chunkId] + ".chunk.js";
};